import React from "react";
import { useAuth } from "./auth";

/**
 * Hook para gerenciamento de permissões.
 * @returns object
 */
export function usePermissions() {

    const { data } = useAuth();

    /**
     * Verifica se o usuário possui permissão.
     * @param permission
     * @returns boolean
     */
    const has = React.useCallback((permission: string) => {
        if (data.user && data.user.permissoes) {
            return data.user.permissoes.includes(permission);
        }
        return false;
    }, [data]);

    /**
     * Verifica se o menu deve ser exibido (se tiver qualquer item).
     * @param permission
     * @returns object
     */
    const menu = React.useCallback((permission: string | string[]) => {
        if (data.user && data.user.permissoes && data.user.permissoes.length > 0) {
            if (Array.isArray(permission)) {
                return permission.some(o => {
                    return data.user.permissoes.some(p => p === o)
                }) ? {} : { display: 'none' };
            } else {
                return data.user.permissoes.some(p => p === permission) ? {} : { display: 'none' };
            }
        }
        return { display: 'none' };
    }, [data]);

    /**
     * Verifica se o elemento deve ser exibido.
     * @param permission
     * @returns object
     */
    const style = React.useCallback((permission: string) => {
        return has(permission) ? {} : { display: 'none' };
    }, [has]);

    return { has, menu, style };
}